import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

// Import the Google Maps API key from the map.config.ts file
import mapConfig from '@/pages/mapView/components/map/map.config';
const TOKEN_GOOGLE = mapConfig.TOKEN_GOOGLE;

// Initialize Google Maps only once
let isGoogleMapsInitialized = false;
let initializedLanguage = null;

export const initGoogleMaps = (lang = 'en') => {
  const language = lang === 'he' ? 'iw' : (lang || 'en');

  if (isGoogleMapsInitialized) {
    // If language changes, the app currently does a full reload (see App.vue lang watcher).
    // Avoid re-installing the plugin multiple times.
    if (initializedLanguage === language) return;
    return;
  }

  Vue.use(VueGoogleMaps, {
    load: {
      key: TOKEN_GOOGLE,
      language,
      libraries: ['places', 'visualization', 'geometry']
    },
    installComponents: true // This ensures all components are installed
  });

  isGoogleMapsInitialized = true;
  initializedLanguage = language;
};

// Export the Google Maps components for direct use
export const { gmapApi } = VueGoogleMaps;
